const REVEAL_SELECTOR = '[data-w-id], .motion-reveal';

function stripWebflowHiddenInline(el: HTMLElement) {
  const opacity = el.style.opacity;
  const filter = el.style.filter;
  if (opacity === '0' || filter.includes('blur')) {
    el.style.removeProperty('opacity');
    el.style.removeProperty('filter');
    el.style.removeProperty('transform');
  }
}

/** Scroll-triggered reveal - replaces load-time Webflow fallback animations. */
export function setupScrollMotion(root: HTMLElement): () => void {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const targets = Array.from(root.querySelectorAll<HTMLElement>(REVEAL_SELECTOR));

  if (targets.length === 0) {
    return () => undefined;
  }

  if (reducedMotion) {
    targets.forEach((el) => el.classList.add('motion-inview'));
    return () => undefined;
  }

  targets.forEach((el, index) => {
    el.classList.add('motion-reveal-pending');
    el.style.setProperty('--reveal-index', String(index % 14));
    stripWebflowHiddenInline(el);
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target as HTMLElement;
        el.classList.add('motion-inview');
        el.classList.remove('motion-reveal-pending');
        observer.unobserve(el);
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -6% 0px',
    },
  );

  targets.forEach((el) => observer.observe(el));

  return () => observer.disconnect();
}
